export default "__VITE_PUBLIC_ASSET__37afa6b3__"